import React from 'react';
import breadcrumbs from 'images/breadcrumbs.svg';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import classNames from 'classnames';
import style from './ModalToConfirm.module.scss';

interface IProps {
	onConsentEvent: () => void;
	onFailureEvent: () => void;
	isVisible: boolean;
	description: string;
	additionalContent?: React.ReactNode;
	typeOfInfoIcon?: 'toConfirm' | 'toConfirmPush' | 'toDelete' | 'toArchive' | 'toRestore' | 'withoutIcon';
}

export const ModalToConfirm: React.FC<IProps> = React.memo(
	({ onConsentEvent, onFailureEvent, isVisible, description, additionalContent, typeOfInfoIcon = 'toConfirm' }) => {
		const containerClasses = classNames(style.container, { [style.visible]: isVisible });

		return (
			<div className={containerClasses} data-test={`ModalToConfirm${isVisible ? 'IsVisible' : ''}`}>
				<div className={style.wrapper}>
					<div className={style.closeIconWrapper} onClick={onFailureEvent}>
						<svg className={style.closeIcon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					</div>
					{typeOfInfoIcon === 'toConfirm' && (
						<svg className={style.disketteIcon}>
							<use xlinkHref={`${breadcrumbs}#diskette`} />
						</svg>
					)}
					{typeOfInfoIcon === 'toConfirmPush' && (
						<svg className={style.pushIcon}>
							<use xlinkHref={`${breadcrumbs}#pushUpdateIcon`} />
						</svg>
					)}
					{typeOfInfoIcon === 'toDelete' && (
						<svg className={style.binIcon}>
							<use xlinkHref={`${breadcrumbs}#largeBin`} />
						</svg>
					)}
					{typeOfInfoIcon === 'toArchive' && (
						<svg className={style.archiveIcon}>
							<use xlinkHref={`${breadcrumbs}#largeArchive`} />
						</svg>
					)}
					{typeOfInfoIcon === 'toRestore' && (
						<svg className={style.restoreIcon}>
							<use xlinkHref={`${breadcrumbs}#largeRestore`} />
						</svg>
					)}
					<Text
						className={style.description}
						translationNameSpace="modals"
						translationKey={description}
						size="xxl"
						weight="bold"
						align="center"
					/>
					{additionalContent}
					<div className={style.btnWrapper}>
						<Button theme="secondary" onClick={onFailureEvent} data-test="noButton">
							<Text translationNameSpace="modals" translationKey="noButton" asFragment={true} />
						</Button>
						<Button theme="primaryBlue" onClick={onConsentEvent} type="submit" data-test="yesButton">
							<Text translationNameSpace="modals" translationKey="yesButton" asFragment={true} />
						</Button>
					</div>
				</div>
			</div>
		);
	},
);
